module.exports = __webpack_public_path__ + "media/stylesheets/images/media/banner_media_top-a7644933661a16c75619be1112cef075.png";